<template>
  <BaseGoogleIcon v-bind="style"
                  v-on="$listeners"
                  :content="content"
                  :iconStyle="iconStyle" />
</template>

<script>
  import BaseGoogleIcon from '@base/base-google-icon'
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'IconPrimary',
    inheritAttrs: false,
    components: {
      BaseGoogleIcon,
    },
    props: {
      content: { type: String, required: true },
      fontSize: { type: [Number, String, Object], required: false, default: FontStyle.size.sm },
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      iconStyle: function () {
        return {
          color: this.color.dark3(),
          fontSize: this.fontSize,
        };
      },
      style: function () {
        return {
          fontSize: this.fontSize,
          ...this.$attrs,
        };
      },
    },
  };
</script>
